import React, { useState } from "react";
import styled from "@emotion/styled";
import { Drawer } from "antd5";

import { NoticeViews } from "components/my_feed/NoticeViews";
import Tabs from "components/ui/tabs/Tabs";
import { SavedViewType } from "lib/generated/app-api";
import { IconProps } from "lib/icons/untitled_ui/UIcon";
import PinnedViews from "./lists/PinnedViews";
import RecentViews from "./lists/RecentViews";
import Templates from "./lists/Templates";

type SavedViewsMenuProps = {
  pinnedViews: SavedViewType[];
  recentViews?: SavedViewType[];
  templates?: SavedViewType[];
};

function SavedViewsMenu({ pinnedViews, recentViews, templates }: SavedViewsMenuProps) {
  const [isViewDrawerOpen, setIsViewDrawerOpen] = useState(false);

  const tabItems: {
    key: string;
    label: string;
    children: React.ReactNode;
    badge?: number;
    icon?: IconProps["icon"];
  }[] = [
    {
      key: "pinned",
      label: "Pinned",
      icon: "pin02",
      children: <PinnedViews pinnedViews={pinnedViews} setIsViewDrawerOpen={setIsViewDrawerOpen} />,
    },
    {
      key: "recent",
      label: "Recent",
      icon: "clockRewind",
      children: <RecentViews recentViews={recentViews} setIsViewDrawerOpen={setIsViewDrawerOpen} />,
    },
    {
      key: "templates",
      label: "Templates",
      icon: "stickerSquare",
      children: <Templates templates={templates} setIsViewDrawerOpen={setIsViewDrawerOpen} />,
    },
  ];

  return (
    <SavedViewsMenuWrapper>
      <Drawer
        title="Notice views"
        onClose={() => setIsViewDrawerOpen(false)}
        open={isViewDrawerOpen}
        height={"70vh"}
        placement={"bottom"}
        destroyOnClose
      >
        <NoticeViews onClose={() => setIsViewDrawerOpen(false)} />
      </Drawer>

      <Tabs items={tabItems} defaultValue={tabItems[0].key} fullWidth />
    </SavedViewsMenuWrapper>
  );
}

const SavedViewsMenuWrapper = styled.div({
  display: "flex",
  width: "400px",
  height: "340px",
  maxHeight: "340px",
  flexDirection: "column",
  backgroundColor: "white",
});

export default SavedViewsMenu;
